import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// HubSpot tracking loader. Loaded once, then _hsq.trackPageView fires on route change.
// Excluded on /admin/* and /client-portal per project policy.
const EXCLUDED_PREFIXES = ["/admin", "/client-portal"];
const HS_SCRIPT_ID = "hs-script-loader";
const HS_PORTAL_ID = "8391469";

declare global {
  interface Window {
    _hsq?: unknown[];
  }
}

const isExcluded = (path: string) =>
  EXCLUDED_PREFIXES.some((p) => path === p || path.startsWith(p + "/"));

const HubSpotTracker = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (isExcluded(pathname)) return;
    if (document.getElementById(HS_SCRIPT_ID)) return;
    const s = document.createElement("script");
    s.id = HS_SCRIPT_ID;
    s.async = true;
    s.defer = true;
    s.src = `//js.hs-scripts.com/${HS_PORTAL_ID}.js`;
    document.body.appendChild(s);
  }, [pathname]);

  useEffect(() => {
    if (isExcluded(pathname)) return;
    const _hsq = (window._hsq = window._hsq || []);
    _hsq.push(["setPath", pathname + search]);
    _hsq.push(["trackPageView"]);
  }, [pathname, search]);

  return null;
};

export default HubSpotTracker;
